module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-1.6e92c874.png";